export default __webpack_public_path__ + "static/media/20.8ea02ed7.jpg";